import api from "./apiClient";



// TAG CATEGORIES
const getAllTagsCategories = () => {
    return api.get(`/api/tag-categories`);
}

const createTagCategory = (data: any) => {
    return api.post(`/api/tag-categories`, data);
}

const updateeTagCategory = (id: any, data: any) => {
    return api.put(`/api/tag-categories/${id}`, data);
}

const deleteTagCategory = (id: any) => {
    return api.delete(`/api/tag-categories/${id}`);
}

// TAGS
const getAllFacilityTags = () => {
    return api.get(`/api/facility-tags`);
}

const createFacilityTag = (data: any) => {
    return api.post(`/api/facility-tags`, data);
}

const updateFacilityTag = (id: any, data: any) => {
    return api.put(`/api/facility-tags/${id}`, data);
}

const deleteFacilityTag = (id: any) => {
    return api.delete(`/api/facility-tags/${id}`)
}

// SERVICES
const getAllFacilityServices = () => {
    return api.get(`/api/facility-services`);
}

const createFacilityService = (data: any) => {
    return api.post(`/api/facility-services`, data);
}

const updateFacilityService = (id: any, data: any) => {
    return api.put(`/api/facility-services/${id}`, data)
}

const deleteFacilityService = (id: any) => {
    return api.delete(`/api/facility-services/${id}`)
}

// FACILITY TYPES
const getAllFacilityTypes = () => {
    return api.get(`/api/facility-types`);
}

const createFacilityType = (data: any) => {
    return api.post(`/api/facility-types`, data);
}


const updateFacilityType = (id: any, data: any) => {
    return api.put(`/api/facility-types/${id}`, data)
}

const deleteFacilityType = (id: any) => {
    return api.delete(`/api/facility-types/${id}`)
}

// INSURANCE
const getAllInsurances = () => {
    return api.get(`/api/insurances`);
}

const createInsurance = (data: any) => {
    return api.post(`/api/insurances`, data);
}


const updateInsurance = (id: any, data: any) => {
    return api.put(`/api/insurances/${id}`, data)
}

const deleteInsurance = (id: any) => {
    return api.delete(`/api/insurances/${id}`)
}


// FACILITIES
const getAllFacilities = () => {
    return api.get(`/api/facilities`);
}

const createFacility = (data: any) => {
    return api.post(`/api/facilities`, data);
}

// UPDATE
const updateFacilityData = (id: any, data: any) => {
    return api.put(`/api/facilities/${id}`, data);
}




export {
    getAllTagsCategories,
    createTagCategory,
    getAllFacilityTags,
    createFacilityTag,
    getAllFacilityServices,
    createFacilityService,
    updateFacilityService,
    deleteFacilityService,
    getAllFacilities,
    createFacility,
    updateFacilityData,
    createFacilityType,
    getAllFacilityTypes,
    updateFacilityTag,
    deleteFacilityTag,
    updateFacilityType,
    deleteFacilityType,
    updateeTagCategory,
    deleteTagCategory,
    getAllInsurances,
    createInsurance,
    updateInsurance,
    deleteInsurance
}


